module.exports = __webpack_public_path__ + "static/media/openFresa.88f13397.png";